import React from "react";
import { connect } from "react-redux";
import { createRequest } from "actions/companyAccessRequest";
import logo from "assets/logo.jpg";
import PropTypes from "prop-types";

import Card, { CardBlock } from "components/Card";
import history from "utils/history";
import Translate from "utils/translate";

import styles from "../../SignUp.css";

const { t } = new Translate("SignUp");

const ExistingCompany = ({ companies, registeredUser, requests = [], onRequestAccess }) => (
  <Card className={styles.container}>
    <CardBlock>
      <img alt="" src={logo} width="195" />
    </CardBlock>
    <CardBlock>
      {registeredUser && (
        <p
          dangerouslySetInnerHTML={{
            __html: t("company.welcome", { name: registeredUser.fname }),
          }}
        />
      )}
    </CardBlock>
    <CardBlock>
      {companies &&
        companies.map((company) => {
          const requestForCompany = requests.find((r) => r.company.id === company.id);

          return (
            <div className={styles.company} key={company.id}>
              <div className={styles.wrapper}>
                {company.logoUrl && <img alt="" src={company.logoUrl} />}
                <div className={styles.details}>
                  <div>{company.name}</div>
                  <a href={company.website}>{company.website}</a>
                </div>
                <button
                  className={styles.btn}
                  disabled={!!requestForCompany}
                  onClick={() => onRequestAccess(company.id)}
                >
                  {requestForCompany ? t("company.requestPending") : t("company.requestAccess")}
                </button>
              </div>
            </div>
          );
        })}
    </CardBlock>
    <CardBlock>
      <p
        dangerouslySetInnerHTML={{
          __html: t("company.createNew", {
            link: `/signup/account/new${history.location.search}`,
          }),
        }}
      />
    </CardBlock>
  </Card>
);

ExistingCompany.propTypes = {
  companies: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  registeredUser: PropTypes.shape({ id: PropTypes.number }),
  requests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      company: PropTypes.shape({
        id: PropTypes.number,
      }),
    })
  ),
  onRequestAccess: PropTypes.func.isRequired,
};

const mapStateToProps = ({ companies, companyAccessRequests, registeredUser }) => ({
  companies,
  registeredUser,
  requests: companyAccessRequests,
});

const mapDispatchToProps = (dispatch) => ({
  onRequestAccess: (companyId) => dispatch(createRequest(companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExistingCompany);
